'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = ['M0 96l0 352 144 0 0-272 304 0 0-80-128 0 0-32c0-53-43-96-96-96s-96 43-96 96l0 32-128 0zM176 64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32-96 0 0-32zM288 288l0 64c0 53 43 96 96 96s96-43 96-96l0-64-48 0 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64-48 0z', 'M576 224l-384 0 0 288 384 0 0-288zM336 312l0 40c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64 48 0 0 64c0 53-43 96-96 96s-96-43-96-96l0-64 48 0 0 24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;